<template>
    <div class="profile">
        <!-- <div class="box is-shadowless"> -->
            <div class="columns">
                <!-- Role Sections -->
                <div class="column is-6">
                    <div class="card user-form">
                        <header class="card-header has-background-dark">
                            <p class="card-header-title has-text-light">Roles</p>
                            <div class="buttons">
                                <b-button size="is-small" @click="isCreateRole = true">CREATE</b-button>
                            </div>
                        </header>
                        <div class="card-content scrollable">
                            <!-- Role Table -->
                            <b-table
                                :data="roles"
                                :selected.sync="selectedRole"
                                class="no-wrap is-clipped ellipsis"
                            >
                                <template slot-scope="props">
                                    <b-table-column field="name" label="Roles">{{ props.row.name }}</b-table-column>
                                    <b-table-column width="40">
                                        <template v-if="isSuperAdmin">
                                            <button :class="'button is-small' + (isSystem(props.row) ? ' is-info' : '')"
                                            @click="toggleTag(props.row, $event)"
                                            >
                                                SYSTEM
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button class="button is-small is-danger" v-if="isSystem(props.row)"
                                            title="This role is managed by the system and can be cloned, but not edited">
                                                SYSTEM
                                            </button>
                                        </template>
                                    </b-table-column>
                                    <b-table-column field="id" label="Action" width="40">
                                        <b-button
                                            @click.prevent="cloneRoleModal(props.row)"
                                            size="is-small"
                                        >CLONE</b-button>
                                    </b-table-column>
                                </template>
                            </b-table>
                            <!-- Edn Role Table -->
                        </div>
                    </div>
                </div>
                <!-- End Role Sections -->

                <!-- Permissions Sections -->
                <div class="column is-6">
                    <div class="card user-form">
                        <header class="card-header has-background-dark">
                            <p class="card-header-title has-text-light">Permissions</p>
                        </header>
                        <div class="card-content scrollable">
                            <!-- Permissions Table -->
                            <permissionTable
                                :role="selectedRole"
                                :name="selectedRole.name ? selectedRole.name : null"
                                :params="{ type: 'user' }"
                                :nativeRoles="nativeRoles"
                            />
                        </div>
                    </div>
                </div>
                <!-- End Permissions Sections -->
            </div>
        <!-- </div> -->
        <!-- Create Role -->
        <b-modal :active.sync="isCreateRole" trap-focus aria-role="dialog" aria-modal :width="640">
            <createRoleModal @created="fetchRoles"/>
        </b-modal>
        <!-- Clone Role -->
        <b-modal :active.sync="isCloneRole" trap-focus aria-role="dialog" aria-modal :width="640">
            <cloneRoleModal @cloned="fetchRoles" :cloneRole="cloneRole"/>
        </b-modal>
    </div>
</template>

<script>
import { RoleService } from "@/services/role.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import permissionTable from "./partials/permissionTable";
import createRoleModal from "./partials/createRoleModal";
import cloneRoleModal from "./partials/cloneRoleModal";
export default {
    mounted() {
        this.getTags();
        this.fetchRoles();
    },
    components: {
        permissionTable,
        createRoleModal,
        cloneRoleModal
    },
    data: () => ({
        roleService: RoleService,
        roles: [],
        nativeRoles: [],
        selectedRole: {},
        isCreateRole: false,
        isCloneRole: false,
        cloneRole: null
    }),
    computed: {
        isSuperAdmin() {
            return this.$store.getters["Auth/hasRole"]('superadmin');
        },
    },
    methods: {
        async fetchRoles() {
            const params = { type: 'person', includes: "permissions" };
            await this.roleService.all(params).then(response => {
                // this.jsonRolesTags = response.data.map(element => element.relationships.tags.data);
                // this.tags = response.included.filter(element => element.type == 'tags').map(element => element.attributes.pivot);
                let roles = JsonDenormalizer.denormalize(response);
                if (!this.isSuperAdmin) {
                    roles = roles.filter(element => element.name.toLowerCase() != 'superadmin');
                }
                this.roles = roles;
                // this.selectedRole = roles[0];
            });

        },
        permissionUpdated(role) {
            this.selectedRole = role;
            let objIndex = this.roles.findIndex(data => data.id == role.id);
            this.roles[objIndex] = role;
        },
        cloneRoleModal(role) {
            this.cloneRole = role;
            this.isCloneRole = true;
        },
        async toggleTag(role, event) {
            await RoleService.toggleTag({id: role.id}).then(response => {
                this.$buefy.toast.open({
                  message: "Success",
                  type: "is-success",
                  position: "is-top-right"
                });       
            });
            event.target.classList.toggle('is-info')
        },
        isSystem(role) {
            return this.nativeRoles.find(element => element.id == role.id && element.tags.length && element.tags[0].pivot.archived_at == null);
        },
        async getTags() {
            await RoleService.getTags().then(response => {
                this.nativeRoles = response;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.scrollable {
    height: calc(88vh - 44px - 56px);
}
.b-table .table:focus {
    border-color: transparent !important;
    outline: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Roles/index.vue